import React from 'react';
import CardHeader from './CardHeader';
import { FeatureContainer } from '../Containers/FeatureContainer';
import CardBody, { CardLabel } from './CardBody';
import CardFooter, { CardFooterLinks, CardFooterBtns } from './CardFooter';

export interface CardViewProps {
  title: string;
  subTitle?: string;
  desc: string;
  labels?: CardLabel[];
  btns?: CardFooterBtns[];
  links?: CardFooterLinks[];
  footerTitle?: string;
  onClick?: (name: string) => void;
}

export const CardView = ({
  title,
  subTitle,
  desc,
  labels,
  footerTitle,
  btns,
  links,
  onClick
}: CardViewProps) => {
  return (
    <FeatureContainer>
      <CardHeader title={title} subTitle={subTitle} />
      <CardBody labels={labels} desc={desc} />
      <CardFooter
        onClick={() => onClick(title)}
        btns={btns}
        links={links}
        title={footerTitle}
      />
    </FeatureContainer>
  );
};
